<template>
  <div class="w-table w-table--wrap">
    <div class="w-table__scroll-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
           <th class="w-table__header  text-center" width="1%">BIL</th>
            <th class="w-table__header  text-center">NAMA</th>
            <th class="w-table__header  text-center">CATATAN</th>
            <th class="w-table__header  text-center">TARIKH</th>
            <th class="w-table__header  text-center">TINDAKAN</th>      
        </tr>
      </thead>

      <tbody>
        <template v-for="(dt, ind) in datas" :key="ind">
          <tr class="w-table__row" >
            <td class="w-table__cell text-center" style="padding-top:10px">{{ind+1}}</td>
            <td class="w-table__cell text-center" style="padding-top:10px" >{{dt.nama}}</td>
            <td class="w-table__cell text-center" style="padding-top:10px" >{{dt.remark}}</td>
            <td class="w-table__cell text-center" style="padding-top:10px" >{{dt.created_at}}</td>
            <td class="w-table__cell text-center" >
              
              <w-button dark class="info-dark1--bg" @click="papar(dt)" >
                 <w-icon class="mr1">fal fa-eye</w-icon> PAPAR
             </w-button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>

 
  <w-dialog
    v-model="dialog_papar.show"
    :fullscreen="dialog_papar.fullscreen"
    :width="dialog_papar.width"
    :persistent="dialog_papar.persistent"
    :persistent-no-animation="dialog_papar.persistentNoAnimation"
    title-class="primary-dark1--bg white"
  >
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Jejak Audit Ternakan
    </template>

    <div class="w-table-wrap" style="max-height: 400px;">
      <table class="w-table" color="light">
        <thead>
          <tr>
            <!-- Tambah lajur STATUS -->
            <th class="w-table__header text-center" width="10%">STATUS</th>
            <th class="w-table__header text-center">PREMIS</th>
            <th class="w-table__header text-center">JENIS TERNAKAN</th>
            <th class="w-table__header text-center">NO PENDAFTARAN</th>
            <th class="w-table__header text-center">ID | NAMA TERNAKAN</th>
            <th class="w-table__header text-center">BAKA</th>
            <th class="w-table__header text-center">JURUSAN TERNAKAN</th>
            <th class="w-table__header text-center">NAMA BAPA</th>
            <th class="w-table__header text-center">ID BAPA</th>
            <th class="w-table__header text-center">NAMA IBU</th>
            <th class="w-table__header text-center">ID IBU</th>
            <th class="w-table__header text-center">GENERASI</th>
            <th class="w-table__header text-center">NAMA TERNAKAN</th>
            <th class="w-table__header text-center">JANTINA</th>
            <th class="w-table__header text-center">UMUR</th>
          </tr>
        </thead>

        <tbody>
          
          <template v-if="selectedAuditDetail.id">
            
            <tr>
              <td class="text-center font-weight-bold">SEBELUM</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.premis ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_ternakan ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.kode ?? '-' }}</td>
              <td class="text-center">
                {{
                  selectedAuditDetail?.json_sebelum
                    ? (selectedAuditDetail.json_sebelum.id_ternakan ?? '-') + ' - ' +
                      (selectedAuditDetail.json_sebelum.nama ?? '-')
                    : '-'
                }}
              </td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_baka ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_jurusan ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_status ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.nama_bapa ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.id_bapa ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.nama_ibu ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.id_ibu ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.lkp_gred ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sebelum?.jantina ?? '-' }}</td>
              <td class="text-center">
                {{
                  selectedAuditDetail?.json_sebelum?.tarikh_lahir
                    ? $zutil.umurbulan(selectedAuditDetail.json_sebelum.tarikh_lahir)
                    : '-'
                }}
              </td>
            </tr>
            
            <tr>
              <td class="text-center font-weight-bold">SELEPAS</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.premis ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_ternakan ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.kode ?? '-' }}</td>
              <td class="text-center">
                {{
                  selectedAuditDetail?.json_sesudah
                    ? (selectedAuditDetail.json_sesudah.id_ternakan ?? '-') + ' - ' +
                      (selectedAuditDetail.json_sesudah.nama ?? '-')
                    : '-'
                }}
              </td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_baka ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_jurusan ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_status ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.nama_bapa ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.id_bapa ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.nama_ibu ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.id_ibu ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.lkp_gred ?? '-' }}</td>
              <td class="text-center">{{ selectedAuditDetail.json_sesudah?.jantina ?? '-' }}</td>
              <td class="text-center">
                {{
                  selectedAuditDetail?.json_sesudah?.tarikh_lahir
                    ? $zutil.umurbulan(selectedAuditDetail.json_sesudah.tarikh_lahir)
                    : '-'
                }}
              </td>

            </tr>
          </template>
          
          <template v-else>
            <tr>
              <td colspan="14" class="text-center">Sila pilih satu rekod untuk dipaparkan.</td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <template #actions>
      <div class="spacer"></div>
      <w-button
        style="background-color:#f0f0f0;border:2px solid red;color:#333;font-size:11px;"
        @click="dialog_papar.show = false"
      >
        TUTUP
      </w-button>
    </template>
  </w-dialog>
</div>
</template>

<script>
export default {
  name: "Pemilik",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      form : {},
      datas : [], 
      selectedAuditDetail: {}, 
      dialog_papar: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1200,
      },
    }
  },
  methods:{
    getData(){
      this.$zcomm.get(this.api_service + 'ternakan/audit_ternakan/'+this.data.id, {}).then(res => {
        this.datas = res
      })
    },
    papar(dt){
      this.selectedAuditDetail = dt;
      this.dialog_papar.show = true;
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped>
/* Tambahkan sedikit gaya untuk menjadikan label lebih menonjol */
.font-weight-bold {
  font-weight: bold;
}
</style>